import React from 'react';
import { PopoverButton } from 'shared/components/PopoverButton';
import { PrelovedItemFragment } from '../../generated.graphql';


interface Props {
  item: PrelovedItemFragment;
  className?: string;
  caret?: boolean;
}


export const PrelovedConditionReport = (props: Props) => (
  <>
    <p>{props.item.prelovedConditionReport}</p>
    {(props.item.modelNumber || props.item.serialNumber) && 
      <p className="font-weight-bold d-flex flex-wrap">
        {props.item.modelNumber && <span className="mr-4">Model number: {props.item.modelNumber}<br/></span>}
        {props.item.serialNumber && <span>Serial number: #{props.item.serialNumber}</span>}
      </p>
    }
  </>
)


export const PrelovedConditionReportButton = (props: Props) => (
  <PopoverButton buttonText="Preloved condition report" className={props.className} caret={props.caret}>
    <div className="small">
      <PrelovedConditionReport item={props.item}/>
    </div>
  </PopoverButton>
)

